import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
const SchoolStrength = () => {  
  useEffect(() => {
    document.title = 'School Strength - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>School Strength</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="table-responsive maintable">
                    <table className="table">
                        <tbody>
                            <tr>
                                <th colspan="6">ST. FRANCIS XAVIER SCHOOL : TALWANDI RANA &nbsp; SCHOOL STRENGTH </th>
                            </tr>
                            <tr>
                                <th><b>Class</b></th>
                                <th><b>Lily</b></th>
                                <th><b>Rose</b></th>
                                <th><b>Tulip</b></th>
                                <th><b>Lotus</b></th>
                                <th><b>Total</b></th>
                            </tr>
                            <tr>
                                <td>NUR</td>
                                <td>8</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>8</td>
                            </tr>
                            <tr>
                                <td>L.K.G</td>
                                <td>17</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>17</td>
                            </tr>
                            <tr>
                                <td>U.K.G</td>
                                <td>22</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>22</td>
                            </tr>
    
    
                            <tr>
                                <td>I</td>
                                <td>25</td>
                                <td></td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>25</td>
                            </tr>
    
    
                            <tr>
                                <td>II</td>
                                <td>31</td>
                                <td>25</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>56</td>
                            </tr>
    
                            <tr>
                                <td>III</td>
                                <td>28</td>
                                <td>27</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>55</td>
                            </tr>
    
    
                            <tr>
                                <td>IV</td>
                                <td>32</td>
                                <td>33</td>
                                <td></td>
                                <td>&nbsp;</td>
                                <td>65</td>
                            </tr>
    
                            <tr>
                                <td>V</td>
                                <td>27</td>
                                <td>28</td>
                                <td></td>
                                <td>&nbsp;</td>
                                <td>55</td>
                            </tr>
                            <tr>
                                <td>VI</td>
                                <td>37</td>
                                <td>36</td>
                                <td></td>
                                <td>&nbsp;</td>
                                <td>73</td>
                            </tr>
    
                            <tr>
                                <td>VII</td>
                                <td>36</td>
                                <td>33</td>
                                <td>30</td>
                                <td>    </td>
                                <td>99</td>
                            </tr>
                            <tr>
                                <td>VIII</td>
                                <td>30</td>
                                <td>28</td>
                                <td>26</td>
                                <td></td>
                                <td>84</td>
                            </tr>
                            <tr>
                                <td>IX</td>
                                <td>35</td>
                                <td></td>
                                <td>37</td>
                                <td>33</td>
                                <td>105</td>
                            </tr>
                            <tr>
                                <td>X</td>
                                <td>24</td>
                                <td>29</td>
                                <td>26</td>
                                <td>29</td>
                                <td>108</td>
                            </tr>
    
                            <tr>
                                <td>XI-COM</td>
                                <td>18</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>18</td>
                            </tr>
    
    
                            <tr>
                                <td>XI-SCI</td>
                                <td>25</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>25</td>
                            </tr>
    
                            <tr>
                                <td>XI-ARTS</td>
                                <td>13</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>13</td>
                            </tr>
    
                            <tr>
                                <td>XII-COM</td>
                                <td>27</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>27</td>
                            </tr>
    
                            <tr>
                                <td>XII-SCI</td>
                                <td>18</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>18</td>
                            </tr>
    
                            <tr>
                                <td>XII ARTS</td>
                                <td>20</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>20</td>
                            </tr>
    
                            <tr>
                                <td>TOTAL</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>893</td>
                            </tr> 
                        </tbody>
                    </table>
                </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default SchoolStrength;
